import { useState, useEffect } from 'react';
import { getCacheInfo, clearCache } from '../services/api';

export const useCacheDebug = () => {
  const [cacheInfo, setCacheInfo] = useState({});
  const isVisible = import.meta.env.DEV;

  const refreshCacheInfo = () => {
    setCacheInfo(getCacheInfo());
  };

  const handleClearCache = () => {
    clearCache();
    refreshCacheInfo();
  };

  useEffect(() => {
    if (!isVisible) return;

    refreshCacheInfo();
    const interval = setInterval(refreshCacheInfo, 1000); // Обновляем каждую секунду
    return () => clearInterval(interval);
  }, [isVisible]);

  return {
    cacheInfo,
    isVisible,
    refreshCacheInfo,
    handleClearCache
  };
}; 
